// extracted by mini-css-extract-plugin
module.exports = {"delete-modal-container":"DeleteBoxModal_delete-modal-container__1Zp9Y","delete-modal-text":"DeleteBoxModal_delete-modal-text__19_tJ"};